// import ChessRestClient from "../Api/ChessRestClient";
// import { getLocalStorage } from "../Utils/CommonUtils";
import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

type payloadProps = {
  tournament_id: number;
  player_id: number;
  responses: {
    question_id: number;
    response: string;
  }[];
  sender: string;
};

export default function useSaveTournamentQuestionsResponse() {
  const ChatRestClient = useChatRestClient();
  const mutation = useMutation(async (data: payloadProps ) => {
    // TODO: remove the comment
    const response = await ChatRestClient.post('/whatsapp/v1/save_feedback_responses_api', data);
    return response.data;
  });

  return {
    ...mutation,
    isLoading: mutation.isLoading,
  };
}
